<template>
  <UiAdditionalInformation path="/tilleggsopplysninger/nyhetsbrev" />
</template>
